import { render, staticRenderFns } from "./CollegeSubscriptionPracticeTests.vue?vue&type=template&id=3e3d1bfa"
import script from "./CollegeSubscriptionPracticeTests.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionPracticeTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports